import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';


import { store } from './app/store';
import { persistor } from './app/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";

import { PersistGate } from 'redux-persist/integration/react';
import { SessionProvider } from "next-auth/react"


// Polyfill to get randomUUID working in a non secure browser, can delete on deployement
if (!crypto.randomUUID) {
  crypto.randomUUID = function() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  };
}

// NOTE: handleLogin and handleLogOut are empty and remain on purpose for now
// They are a remainder from the msal login build - all original components expect to receive them as props
// Currently they hold no otherwise functional purpose 

let handleLogIn = () => {}

async function handleLogOut() {};



ReactDOM.render(
  <React.StrictMode>
    <SessionProvider basePath={process.env.REACT_APP_SESSION_URL}>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App onLogIn={handleLogIn} onLogOut={handleLogOut}/>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </SessionProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
